import ptLocale from 'element-ui/lib/locale/lang/pt' //引入element语言包
const pt = {
  Login: {
    ToLogin: 'iniciar sessão',
    PhoneLogin: 'Iniciar sessão com o número de telefone',
    EmailLogin: 'Login de e- mail',
    PhonePlaceholder: 'Introduza o seu número de telefone',
    EmailPlaceholder: 'Enter email',
    Code: 'Código de verificação',
    and: 'e',
    BeforeText: 'Criar uma conta representa seu acordo e conformidade',
    UserAgreement: 'Acordo do Utilizador',
    privacy: 'Política de Privacidade',
    errorMessage: 'Erro no código de verificação',
    readTitle: 'Leia e concorde com o seguinte acordo',
    readBefore: 'Para garantir a segurança de suas informações pessoais, leia e concorde primeiro',
    cancel: 'cancelar',
    agree: 'Concordar e continuar',
    error1:'Por favor, insira um endereço de e-mail válido',
    error2:'Digite o número correto',
    error3:'Por favor, insira o código de verificação',
    success:'Login com sucesso'
  },
  ...ptLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default pt;
